// Store
import store from "@/store";

export interface AppAdministratorResourcesExercisesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    type: string;
    description: string;
    url: string;
  };
}

export class AppAdministratorResourcesExercisesListFormCreate implements AppAdministratorResourcesExercisesListFormCreate {
  organization_id: string;
  content: {
    name: string;
    type: string;
    description: string;
    url: string;
  };

  constructor() {
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.content = {
      name: "",
      type: "",
      description: "",
      url: "",
    };
  }
}